module.exports = __webpack_public_path__ + "static/img/101862.afef4cf5.png";